



































import {Component, Prop, Provide, Vue} from "vue-property-decorator";
@Component({
    name: "ManualUpgradeTicketDialogue",
    components: {
        MaskComponent: () => import("@/components/Mask.vue")
    }
})
export default class ApplicationReview extends Vue {
    @Provide() private resultData: any = []; // 列表结果
    @Provide() private ManualUpgradeTicketDialogueForm: any = {
        OverdueDay: ""
    };
    @Provide() private rules: any = {
        OverdueDay: [{ required: true, message: 'Pls enter a number value', trigger: 'blur' }]
    };
    // lee 手动升级操作的接口请求是否完成，布尔值
    @Provide() private isGetManualUpgradeTicketActionDone: boolean = false;
    // get ReduceTypeEnumList(): any {
    //   return this.ReduceTypeEnum;
    // }
    // set ReduceTypeEnumList(param: any): void {
    //   let arr = Reflect.ownKeys(param).map((item: any) => {});
    //   this.ReduceTypeEnum = arr;
    // }
    private validateNumberInput(e: any) {
      if(/\./.test('' + e)) {
        let val =  ('' + e).split('').splice(0, ('' + e).indexOf('.')).join()
        this.ManualUpgradeTicketDialogueForm.OverdueDay = val;
      }
    }
    private getManualUpgradeTicketAction() {
        let _form: any = this.$refs["ManualUpgradeTicketDialogueForm"];
        _form.validate((valid: any, obj: any) => {
            if (valid) {
                this.isGetManualUpgradeTicketActionDone = true;
                this.getManualUpgradeTicket();
                return true;
            } else {
                return false;
            }
        });
    }
    private dwManualUpgradeTicketReqParams() {
        return {
            OverdueDay: +this.ManualUpgradeTicketDialogueForm.OverdueDay
        };
    }
    private async getManualUpgradeTicket() {
        const {
            setManualUpgradeTicketReq,
            getManualUpgradeTicketRequest
        }: any = await import("@/request/manualUpgradeTicket");
        let res = await getManualUpgradeTicketRequest.handleHttp(
            setManualUpgradeTicketReq(this.dwManualUpgradeTicketReqParams(), this),
            this
        );
        if (res && res.right) {
            this.isGetManualUpgradeTicketActionDone = res.loading
                ? res.loading
                : false;
          let _txt: any = this.$t('OrderStatus.manuoverdueDays');
          this.$message({
            type: "success",
            message: _txt
          });
          this.$emit("hideManualUpgradeTicketDialogue", {
            hidden: true,
            val: null
          });
        } else {
          let _txt: any = this.$t('OrderStatus.manuoverdueDaysFailed');
            this.$message({
                type: "error",
                message: _txt
            });
        }
        this.isGetManualUpgradeTicketActionDone = false;
    }
    private hideMaskVue() {
        this.$emit("hideManualUpgradeTicketDialogue", {
            hidden: true,
            val: null
        });
    }
}
